
<template>
  <section id="dashboard-ecommerce">
    <b-row class="match-height">
      <b-col xl="12" md="12" >

        <b-card
            v-if="array"
            no-body
            class="card-statistics"
          >
   
          <b-card-body class="statistics-body">
            <b-row>

              <!-- Saldo -->
              <b-col
                xl="3"
                sm="6"
                :class="saldoEmpresa.customClass"
              >
                <b-media no-body>
                  <b-media-aside

                    class="mr-2"
                  >
                    <b-avatar
                      size="48"
                      :variant="saldoEmpresa.color"
                    >
                      <feather-icon
                        size="24"
                        :icon="saldoEmpresa.icon"
                      />
                    </b-avatar>
                  </b-media-aside>
                  <b-media-body class="my-auto">
                    <h4 class="font-weight-bolder mb-0">
                      {{ "R$ "+ formatPriceR(saldoEmpresa.title) }}
                    </h4>
                    <b-card-text class="font-small-3 mb-0">
                      {{ saldoEmpresa.subtitle }}
                    </b-card-text>
                  </b-media-body>
                </b-media>
              </b-col>
              
              <!-- Recebido hoje -->
              <b-col
                xl="3"
                sm="6"
                :class="recebidosHoje.customClass"
              >
                <b-media no-body>
                  <b-media-aside

                    class="mr-2"
                  >
                    <b-avatar
                      size="48"
                      :variant="recebidosHoje.color"
                    >
                      <feather-icon
                        size="24"
                        :icon="recebidosHoje.icon"
                      />
                    </b-avatar>
                  </b-media-aside>
                  <b-media-body class="my-auto">
                    <h4 class="font-weight-bolder mb-0">
                      {{ "R$ "+ formatPriceR(recebidosHoje.title) }}
                    </h4>
                    <b-card-text class="font-small-3 mb-0">
                      {{ recebidosHoje.subtitle }}
                    </b-card-text>
                  </b-media-body>
                </b-media>
              </b-col>

              <!-- Recebido Mes -->
              <b-col
                xl="3"
                sm="6"
                :class="recebidosMes.customClass"
              >
                <b-media no-body>
                  <b-media-aside

                    class="mr-2"
                  >
                    <b-avatar
                      size="48"
                      :variant="recebidosMes.color"
                    >
                      <feather-icon
                        size="24"
                        :icon="recebidosMes.icon"
                      />
                    </b-avatar>
                  </b-media-aside>
                  <b-media-body class="my-auto">
                    <h4 class="font-weight-bolder mb-0">
                      {{ "R$ "+ formatPriceR(recebidosMes.title) }}
                    </h4>
                    <b-card-text class="font-small-3 mb-0">
                      {{ recebidosMes.subtitle }}
                    </b-card-text>
                  </b-media-body>
                </b-media>
              </b-col>

              <!-- Transferencias -->
              <!-- <b-col
                xl="3"
                sm="6"
                :class="transferencia.customClass"
              >
                <b-media no-body>
                  <b-media-aside

                    class="mr-2"
                  >
                    <b-avatar
                      size="48"
                      :variant="transferencia.color"
                    >
                      <feather-icon
                        size="24"
                        :icon="transferencia.icon"
                      />
                    </b-avatar>
                  </b-media-aside>
                  <b-media-body class="my-auto">
                    <h4 class="font-weight-bolder mb-0">
                      {{ "R$ "+ formatPriceR(transferencia.title) }}
                    </h4>
                    <b-card-text class="font-small-3 mb-0">
                      {{ transferencia.subtitle }}
                    </b-card-text>
                  </b-media-body>
                </b-media>
              </b-col> -->
              
        
            </b-row>
            
          </b-card-body>
        </b-card>
       
      </b-col>
     
    </b-row>

</section>
  
</template>

<script>
import {
  BCard, BCardHeader, BCardTitle, BCardText, BCardBody, BRow, BCol, BMedia, BMediaAside, BAvatar, BMediaBody,
} from 'bootstrap-vue'

export default {
  components: {
    BRow,
    BCol,
    BCard,
    BCardHeader,
    BCardTitle,
    BCardText,
    BCardBody,
    BMedia,
    BAvatar,
    BMediaAside,
    BMediaBody,
  },
  props: {
    data: {
      type: Array,
      default: () => [],
    },
  },

  data() {
      return {
          statusTab:true,
          array:[
                {
                  icon: 'TrendingUpIcon',
                  color: 'light-primary',
                  title: '0',
                  subtitle: 'Cobranças emitidas',
                  customClass: 'mb-2 mb-xl-0',
                },
                {
                  icon: 'DollarSignIcon',
                  color: 'light-success',
                  title: 'R$ 0,00',
                  subtitle: 'Recebidos',
                  customClass: '',
                },
                {
                  icon: 'UserIcon',
                  color: 'light-info',
                  title: '0',
                  subtitle: 'Clientes',
                  customClass: 'mb-2 mb-xl-0',
                },
                {
                  icon: 'BoxIcon',
                  color: 'light-danger',
                  title: '1',
                  subtitle: 'Estabelecimentos',
                  customClass: 'mb-2 mb-sm-0',
                }
                
              ]
                  
                  
              
      }
  },
  created() {
    this.$store.dispatch("estabelecimentos/saldoEmpresa");
    this.$store.dispatch("estabelecimentos/saldoHoje");
    this.$store.dispatch("estabelecimentos/saldoMes");
  },
  
  computed:{
      saldoEmpresa(){
               const a ={
                      icon: 'DollarSignIcon',
                      color: 'light-success',
                      title: this.$store.state.estabelecimentos.saldoEmpresa,
                      subtitle: 'Saldo Total',
                      customClass: ' mt-2 mb-2 mb-xl-0',
                  }
            
          return a
                
      },

      recebidosHoje(){
                  
                  const a=   {
                         icon: 'DollarSignIcon',
                         color: 'light-primary',
                         title: this.$store.state.estabelecimentos.saldoHoje,
                         subtitle: 'Recebidos Hoje',
                         customClass: ' mt-2 mb-2 mb-xl-0',
                     }
   
                     return a
                 },

      recebidosMes(){
                  
               const a=   {
                      icon: 'DollarSignIcon',
                      color: 'light-info',
                      title: this.$store.state.estabelecimentos.saldoMes,
                      subtitle: 'Recebidos Mês',
                      customClass: ' mt-2 mb-2 mb-xl-0',
                  }

                  return a
              },
        // transferencia(){
                  
        //           const a=   {
        //                  icon: 'DollarSignIcon',
        //                  color: 'light-danger',
        //                  title: 'R$ '+ this.$store.state.estabelecimentos.recebidoshoje,
        //                  subtitle: 'Total Transferências',
        //                  customClass: ' mt-2 mb-2 mb-xl-0',
        //              }
   
        //              return a
        //          },
        
      estabelecimento() {
        return this.$store.state.estabelecimentos.estabelecimento.allEstablishment;
      },
      usuario() {
        return this.$store.state.login.usuario;
      },
      lista_estabelecimentos() {
        return this.$store.state.estabelecimentos.lista_estabelecimentos.data;
      },
     
  },
  methods:{
        
    formatPriceR(value) {
          let novo = parseInt(value)
          let val = novo.toFixed(2).replace(".", ",");
          return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
        },
  
  
      }
}
</script>
